import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * 页面路由切换时自动滚动到顶部
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // 页面路由变化时，滚动到顶部
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
